import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import getLocations$ from '../../../../../requests/get-locations.tsx';
import { fetchLocationsDataSuccess, fetchDataFailure } from '../../action-creators/index.tsx';
import { FETCH_DATA_REQUEST } from '../../action-types/index.tsx';
import { recentProjectsSelector } from '../../selectors/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetchLocationsData = (action$: any, store: any) =>
	action$.ofType(FETCH_DATA_REQUEST).switchMap(() => {
		const state = store.getState();
		return (
			getLocations$(recentProjectsSelector(state))
				.map(fetchLocationsDataSuccess)
				// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
				.catch((anotherError) => Observable.of(fetchDataFailure(anotherError)))
		);
	});

export default fetchLocationsData;
